const doc = [({"en":({"js":({"admin":({"economy":({"employees":({"employees":"Employees"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;